import { render, staticRenderFns } from "./CoozzyNotification.vue?vue&type=template&id=21847cd0&scoped=true"
import script from "./CoozzyNotification.vue?vue&type=script&lang=js"
export * from "./CoozzyNotification.vue?vue&type=script&lang=js"
import style0 from "./CoozzyNotification.vue?vue&type=style&index=0&id=21847cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21847cd0",
  null
  
)

export default component.exports